export const testAdministrationConstants = {
  FETCH_TEST_ADMINISTRATION: "FETCH_TEST_ADMINISTRATION",
  FETCH_TEST_ADMINISTRATION_SUCCESS: "FETCH_TEST_ADMINISTRATION_SUCCESS",
  FETCH_TEST_ADMINISTRATION_FAILED: "FETCH_TEST_ADMINISTRATION_FAILED"
}
